import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DropdownManagerService {
  isAnyDropdownOpen(): boolean {
    return !!document.querySelector('.popup.popup_position, .dds-select.show');
  }

  closeAllDropdowns(): void {
    const dropdowns = document.querySelectorAll(
      '.popup.popup_position, .dds-select.show',
    );

    dropdowns.forEach((el: Element) => {
      (el as HTMLElement).dispatchEvent(
        new KeyboardEvent('keydown', { key: 'Escape' }),
      );
    });
  }
}
